import React from 'react';

type GridContainerProps = {
    children: React.ReactNode;
    className?: string;
}

export const GridContainer: React.FC<GridContainerProps> = ({ children, className }) => {
    return <div className={className ? className : "grow grid grid-col-1 gap-12 md:grid-cols-2"}>{children}</div>
}